<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
  </ngx-spinner>

<ngx-datatable 
    style="margin-top: 30px;"
    #packageTable 
    class='material striped datatable' 
    [rows]='events' 
    [columnMode]='"force"'
    [headerHeight]='40' 
    [sorts]="[{prop: 'startDate', dir: 'desc'}]"
    [footerHeight]='20' 
    [scrollbarH]="true" 
    [scrollbarV]="true" 
    [rowHeight]="40"
    [reorderable]="true">

    <ngx-datatable-column prop="status" [sortable]="true" [width]="60" [minWidth]="60" [maxWidth]="60">
        <ng-template let-column="column"  ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">Status</span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            <div class="center">
                <div placement="right" container="body" tooltip="Cancelled" *ngIf="row.status === 1" style="background-color:orangered;" class="circle"></div>
                <div placement="right" container="body" tooltip="Scheduled" *ngIf="row.status === 2" style="background-color:yellow;" class="circle"></div>
                <div placement="right" container="body" tooltip="Completed" *ngIf="row.status === 3" style="background-color:green;" class="circle"></div>
            </div>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="name" [sortable]="true" width="100">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Event Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.formattedName}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="file" [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Scheduled Date/Time UTC
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.startDate | date:'EEEE, MMMM d, y hh:mm a'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="google" [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span>
                Event Type
            </span>
        </ng-template>
        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
            {{row.type}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="actions" [sortable]="false" [minWidth]="130" [maxWidth]="130">
        <ng-template let-column="column" ngx-datatable-header-template class="actions-row">
            <span>Actions</span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            <button  *ngIf="row.status === 2" (click)="cancelEvent(row.scheduledEventId)">Cancel</button>
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>